import { Box, BoxProps } from '@mui/material'
import { FunctionComponent, ReactNode } from 'react'

export const CenteringBox: FunctionComponent<
  {
    children: ReactNode
  } & BoxProps
> = ({ children, ...rest }) => (
  <Box display="flex" alignItems="center" justifyContent="center" {...rest}>
    {children}
  </Box>
)
